import React from 'react';
import { observer } from 'mobx-react';
import { ProductTagListTemplate } from 'themes/application/product-tag/pages';
import { setCurrentView } from 'core/utils';
import { ProductTagListViewStore } from 'application/product-tag/stores';

@setCurrentView((rootStore) => new ProductTagListViewStore(rootStore), 'productTagListViewStore')
@observer
class ProductTagList extends React.Component {
    render() {
        return <ProductTagListTemplate {...this.props} />
    }
}

export default ProductTagList;